/* eslint-disable react-hooks/exhaustive-deps */
import { TextAlignment } from "@blueprintjs/core"
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import Shortcode from "src/libs/useful/shortcode"
import { getCssDemention } from "src/libs/utilities"
import { ALIGN, HTMLContent, ILandingSection, SELECT_TYPE, TEXT_ALIGN, TEXT_SIZE } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import Background from "../section/Background"
import TextBlock from "../useful/TextBlock"
import Incut from "../contentType/html/Incut"

/* Protopia Ecosystem component */
export interface IHTMLPrimitiveProps {
   
}
const HTMLPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: HTMLContent = (props.primitive || {}) as HTMLContent 
    const { text, max_length, style, className } = primitive 
    const position = primitive.position || {} // usePosition( primitive ) // 

    useEffect(() => {
        addCSSClass(
            `landing-html-${ primitive.id }`,
            ` .landing-html-${ primitive.id } {
                position: absolute;
                width:${ getCssDemention(position.width, "200px") };
                height:${ getCssDemention(position.height, "200px") };
                ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                ${ `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg);` }
                text-align:${ TEXT_ALIGN[ primitive.text_align || ALIGN.START] };
                ${ primitive.text_size   ? `font-size: ${ TEXT_SIZE[ primitive.text_size ] }em;` : "" }
                ${ primitive.text_color  ? `color: ${primitive.text_color};` : "" }
                ${ primitive.font ? `font-family: ${primitive.font }` : "" }
                ${ primitive.font_case ? `text-transform: ${primitive.font_case }` : "" }
                ${ primitive.line_height ? `line-height: ${primitive.line_height }` : "" }
                ${ primitive.letter_spacing ? `letter-spacing: ${primitive.letter_spacing }px` : "" }
            }`
        )
        return () => removeCSSClass(`landing-html-${ primitive.id }`)
    },[ position, primitive ])
          
    return <div>
        {/* <Shortcode 
            className={`pe-primitive-container landing-html-${ primitive.id } ${ !!position.className ? position.className : className || "" }`}
            content={ primitive.text_align + " " +(text || "")}
            max_length={ max_length }
            style={{ ...style, ...position.style }}
            data-primitive-type={primitive["data-primitive-type"]}
        /> */}
        <TextBlock 
            editType={ SELECT_TYPE.CONTENT }
            section={ props.section || {} as ILandingSection }
            data={ primitive }
            columns={ primitive.columns }
            text={ primitive.text }
            columnGap={ primitive.gap }
        >
            <>
                <Incut data={primitive} {...props} section={ props.section || {} as ILandingSection } />
            </>
        </TextBlock>
        <div
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                opacity: 1,
                zIndex: -1
            }}
        >
            <Background section={primitive} />
        </div>
        
    </div>
}
export default HTMLPrimitive